
import { baseUrl } from "../../constants";
import { getDDCompCall } from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add Equipment Tag",
    "tableTitle": "Equipment Tag List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [ getDDCompCall];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/equipment_tag/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/equipment_tag`,
        edit: `${baseUrl}/api/mms/equipment_tag/edit`,
        delete: `${baseUrl}/api/mms/equipment_tag/remove`
    },
    "tableCol": [
        {
            name: 'Equipment Tag',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Equipment Capacity',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Equipment',
            selector: row => row.equipment_id,
            sortable: true
        },
        {
            name: 'Company',
            selector: row => row.comp_id,
            sortable: true
        },
        {
            name: 'Location',
            selector: row => row.loc_id,
            sortable: true
        },
        {
            name: 'Department',
            selector: row => row.department_id,
            sortable: true
        },
        {
            name: 'Area',
            selector: row => row.area_id,
            sortable: true
        },
        {
            name: 'Facility',
            selector: row => row.facility_id,
            sortable: true
        },
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    label: 'Company',
                    name: 'comp_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Location',
                    name: 'loc_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Department',
                    name: 'department_id',
                    "options": [
                        "Agency",
                        "Logistics"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Area',
                    name: 'area_id',
                    "options": [
                        "Ship",
                        "Shore"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Facility',
                    name: 'facility_id',
                    "options": [
                        "Tester",
                        "Crew"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Equipment',
                    name: 'equipment_id',
                    "options": [
                        "Anchor",
                        "Hull"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Equipment Type',
                    // name: 'equipment_type_id',
                    name: 'equipmentType',
                    "required": true
                },
                {
                    type: 'select',
                    label: 'Equipment Capacity',
                    name: 'equipmentCapacity',
                    // name: 'equipment_capacity_id',
                    "required": true
                },
                {
                    type: 'text',
                    label: 'Equipment Tag',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "jobNature": "dgdg"
    }]
}